import React, { useContext, useEffect, useState, useRef } from "react";
import "../../../assests/css/customer/Customerlogin.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import AppContext from "../../../context/AppContext";
import MyNavbar from "../../../components/Customer/Mynavbar/MyNavbar";
import Footer from "../../../components/Customer/Footer/Footer";

const LoginForm = ({ onSwitchToSignup }) => {
  const { baseUrl } = useContext(AppContext);
  const navigate = useNavigate();
  const { regExpChecker, isLoggedIn, setIsLoggedIn, setAuthToken, customer } = useContext(AppContext);

  // 'login' | 'forgot' | 'verify' — koi URL token nahi ab, sab same page pe
  const [authView, setAuthView] = useState("login");

  const [email,          setEmail]          = useState('');
const [password,       setPassword]       = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [isloginloading, setIsloginloading] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  // Forgot / Verify code + reset password ke liye states
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetMessage, setResetMessage] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const forgotSubmittingRef = useRef(false);
  const resetSubmittingRef = useRef(false);

  // const baseUrl = "http://127.0.0.1:8000/api";

  // ── LOGIN ──────
  const loginSubmitData = () => {
    const emailError = regExpChecker("email", email);
    if (emailError) { setErrorMessage(emailError); return; }

    const passwordError = regExpChecker("password", password);
    if (passwordError) { setErrorMessage(passwordError); return; }

    setErrorMessage("");
    setIsloginloading(true);

    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);

    axios.post(`${baseUrl}/customer/auth/login`, formdata)
      .then((response) => {
        console.log(response.data);

        if (response.data.token) {
          // AppContext authToken change hote hi customer profile khud fetch kar lega
          setAuthToken(response.data.token);

          if (remember) {
            localStorage.setItem("CustomerEmail", email);
          } else {
            localStorage.removeItem("CustomerEmail");
          }

          setIsLoggedIn(true);
          navigate("/customer/profile");
        } else if (response.data.not_verified) {
          setUnverifiedEmail(response.data.email || email);
          setAuthView("verify");
          submitResendFromLogin(response.data.email || email);
        } else {
          setErrorMessage(response.data.message || "Invalid email or password");
        }
      })
      .catch(() => {
        setErrorMessage("Something went wrong!");
      })
      .finally(() => {
        setIsloginloading(false);
      });
  };

  const [unverifiedEmail, setUnverifiedEmail] = useState("");

  const submitResendFromLogin = (targetEmail) => {
    setForgotEmail(targetEmail); // verify screen isi email ko use karega
    axios.post(`${baseUrl}/customer/auth/resend-code`, { email: targetEmail }).catch(() => { });
  };

  // ── FORGOT PASSWORD ─────────────────────────────────────
  const submitForgotPassword = () => {
    const emailError = regExpChecker("email", forgotEmail);
    if (emailError) { setForgotMessage(emailError); return; }
    if (forgotSubmittingRef.current) return; // synchronous guard — state se pehle hi rok deta hai
    forgotSubmittingRef.current = true;

    setForgotMessage("");
    setForgotLoading(true);

    axios.post(`${baseUrl}/customer/auth/forgot-password`, { email: forgotEmail })
      .then((res) => {
        if (res.data.success) {
          Swal.fire({
            icon: "success",
            title: "Check your email",
            text: res.data.message,
            timer: 2000,
            showConfirmButton: false,
          });
          setAuthView("verify");
        } else {
          Swal.fire({ icon: "error", title: "Oops...", text: res.data.message });
        }
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      })
      .finally(() => {
        setForgotLoading(false);
        forgotSubmittingRef.current = false;
      });
  };

  // ── RESET PASSWORD ───────────────────────────────────────
  const submitResetPassword = () => {
    if (!resetCode.trim()) { setResetMessage("Enter the verification code"); return; }
    const passwordError = regExpChecker("password", newPassword);
    if (passwordError) { setResetMessage(passwordError); return; }
    if (newPassword !== confirmPassword) { setResetMessage("Passwords do not match"); return; }
    if (resetSubmittingRef.current) return;
    resetSubmittingRef.current = true;

    setResetMessage("");
    setResetLoading(true);

    axios.post(`${baseUrl}/customer/auth/reset-password`, {
      email: forgotEmail,
      code: resetCode,
      password: newPassword,
    })
      .then((res) => {
        if (res.data.success) {
          Swal.fire({
            icon: "success",
            title: "Password updated!",
            text: res.data.message,
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            setAuthView("login");
            setForgotEmail(""); setResetCode(""); setNewPassword(""); setConfirmPassword("");
          });
        } else {
          Swal.fire({ icon: "error", title: "Oops...", text: res.data.message });
        }
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      })
      .finally(() => {
        setResetLoading(false);
        resetSubmittingRef.current = false;
      });
  };

  //   // ── AUTO LOGIN ────────────────────────────────────────────
  //   const autoLoginCustomer = (savedEmail, savedPassword) => {
  //     const formdata = new FormData();
  //     formdata.append("email", savedEmail);
  //     formdata.append("password", savedPassword);

  //     axios.post(`${baseUrl}/customer/auth/login`, formdata)
  //       .then((response) => {
  //      if (response.data.token) {
  //   setAuthToken(response.data.token);
  //   setIsLoggedIn(true);
  //   navigate("/customer/profile");
  // }
  //       })
  //       .catch(() => {
  //         setIsLoading(false);
  //       });
  //   };

  // ── AUTO LOGIN CHECK + PRE-FILL SAVED EMAIL ────────────────
  useEffect(() => {
    // Agar already valid token h (AppContext se aaya), seedha profile pe bhej do
    if (isLoggedIn) {
      navigate("/customer/profile");
      return;
    }

    // Warna sirf email pre-fill kar do (agar pehle "remember me" check kiya tha)
    const savedEmail = localStorage.getItem("CustomerEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRemember(true);
    }
  }, [isLoggedIn, navigate]);

  // ── RENDER ────────────────────────────────────────────────
  return (
    <>
      <MyNavbar />
      <div className="CustomerLoginForm-auth-container CustomerLoginForm-login">

        {/* LEFT */}
        <div className="CustomerLoginForm-neon-panel">
          <h2>WELCOME BACK!</h2>
        </div>

        {/* RIGHT */}
        <div className="CustomerLoginForm-form-panel">

          {authView === "login" && (
            <>
              <h2>Login</h2>

              <input
                type="email"
                placeholder="email@example.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrorMessage(regExpChecker("email", e.target.value));
                }}
              />

              <div className="CustomerLoginForm-password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrorMessage(regExpChecker("password", e.target.value));
                  }}
                />
                <span
                  className="CustomerLoginForm-eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  )}
                </span>
              </div>

              <label>
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={() => setRemember(!remember)}
                />
                Remember Me
              </label>

              <p onClick={() => setAuthView("forgot")}>
                Forgot Password?
              </p>

              {errormessage && <p className="error-text">{errormessage}</p>}

              {isloginloading ? (
                <Spinner />
              ) : (
                <button onClick={loginSubmitData}>Login</button>
              )}

              <p>
                Don't have an account?
                <span onClick={onSwitchToSignup}> Sign Up</span>
              </p>
            </>
          )}

          {authView === "forgot" && (
            <>
              <h2>Forgot Password</h2>

              <input
                type="email"
                placeholder="email@example.com"
                value={forgotEmail}
                onChange={(e) => {
                  setForgotEmail(e.target.value);
                  setForgotMessage(regExpChecker("email", e.target.value));
                }}
              />

              {forgotMessage && <p className="error-text">{forgotMessage}</p>}

              {forgotLoading ? (
                <Spinner />
              ) : (
                <button onClick={submitForgotPassword}>Send Verification Code</button>
              )}

              <p>
                Remembered your password?
                <span onClick={() => setAuthView("login")}> Back to Login</span>
              </p>
            </>
          )}

          {authView === "verify" && (
            <>
              <h2>Enter Code</h2>
              <p style={{ opacity: 0.8 }}>
                Verification code sent for {forgotEmail}
              </p>

              <input
                type="text"
                placeholder="6-digit code"
                maxLength={6}
                value={resetCode}
                onChange={(e) => setResetCode(e.target.value.replace(/\D/g, ""))}
              />

              <div className="CustomerLoginForm-password-wrapper">
                <input
                  type={showNewPassword ? "text" : "password"}
                  placeholder="New password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <span
                  className="CustomerLoginForm-eye-icon"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  )}
                </span>
              </div>

              <div className="CustomerLoginForm-password-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span
                  className="CustomerLoginForm-eye-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  )}
                </span>
              </div>

              {resetMessage && <p className="error-text">{resetMessage}</p>}

              {resetLoading ? (
                <Spinner />
              ) : (
                <button onClick={submitResetPassword}>Update Password</button>
              )}

              <p>
                Didn't get a code?
                <span onClick={() => setAuthView("forgot")}> Resend</span>
              </p>
            </>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
};

export default LoginForm;